import React, {memo, useCallback, useMemo} from "../../../../__snowpack__/pkg/react.js";
import {Select, Input} from "../../../../__snowpack__/pkg/antd.js";
import {InputNumberInteger} from "../../InputNumberInteger.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
const {Option} = Select;
const PriceSelectInput = (props) => {
  const {
    inputProps,
    selectProps = {},
    selectOptionData = [],
    labelKey,
    valueKey,
    onChange,
    inputValueKey = "inputValue",
    selectValueKey = "selectValue",
    value = {}
  } = props;
  const {value: defaultSelectValue, ...otherSelectProps} = selectProps;
  const inputValue = value[inputValueKey];
  const selectValue = value[selectValueKey] || defaultSelectValue;
  const handleInputChange = useCallback((val) => {
    onChange && onChange({inputValue: val, selectValue});
  }, [value]);
  const getSelect = useMemo(() => {
    return /* @__PURE__ */ React.createElement(Select, {
      getPopupContainer: (p) => p,
      ...otherSelectProps,
      value: selectValue
    }, selectOptionData.map((item) => {
      return /* @__PURE__ */ React.createElement(Option, {
        key: item[valueKey] || item["value"],
        value: item[valueKey] || item["value"],
        disabled: item?.disabled
      }, item[labelKey] || item["label"]);
    }));
  }, [selectOptionData, selectValue, selectProps, labelKey, valueKey]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "selectWrapper"
  }, /* @__PURE__ */ React.createElement(Input.Group, {
    compact: true
  }, getSelect, /* @__PURE__ */ React.createElement(InputNumberInteger, {
    ...inputProps,
    value: inputValue,
    onChange: handleInputChange
  })));
};
const Wrapper = styled.div`
  &.selectWrapper {
    .ant-select {
      width: 60px;
    }
    .ant-input-group {
      display: flex;
      align-items: center;
    }
    .ant-input-number {
      flex: 1;
      .ant-input-number-handler-wrap {
        opacity: 1;
      }
    }
  }
`;
export default memo(PriceSelectInput);
